import "./product-details-upload-button.scss";
import EventClass from "common/utils/ui/event-class";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import madeStore from "components/jiffy/vue-product-details-print/store/store";

class ProductDetailsUploadButton extends EventClass {
  #appSelector = "#vue-product-details-print";

  #frontUploadSelector = "#field-artwork-upload-front";

  #wrapperSelector = ".js-product-details-upload-button-wrapper";

  #buyButtonSelector = "#js-product-add-to-cart-sticky-container";

  #artworkExists = false;

  #inputVisible = false;

  get $wrapper() {
    return document.querySelector(this.#wrapperSelector);
  }

  get $buyButton() {
    return document.querySelector(this.#buyButtonSelector);
  }

  get $frontInput() {
    return document.querySelector(this.#frontUploadSelector);
  }

  toggleButtonsVisibility() {
    const uploadButtonShown = !this.#inputVisible && !this.#artworkExists;
    this.$wrapper.classList.toggle("hidden", !uploadButtonShown);
    this.$buyButton?.classList.toggle("force-unsticky", !this.#artworkExists);
  }

  checkInputVisibility() {
    if (!this.$frontInput) {
      this.#inputVisible = false;
    } else {
      const { top: appTop } = this.$frontInput.getBoundingClientRect();
      this.#inputVisible = appTop < window.innerHeight;
    }
  }

  event(e) {
    super.event(e);
    ScrollToElement.scrollIntoViewBySelector(this.#appSelector);
    document.querySelector(this.#frontUploadSelector).click();
  }

  // eslint-disable-next-line max-lines-per-function
  init() {
    if (!this.$wrapper) return;

    document.addEventListener("scroll", () => {
      this.checkInputVisibility();
      this.toggleButtonsVisibility();
    });

    if (document.querySelector(".js-ab-made-monetization-enabled")) {
      madeStore.subscribe(() => {
        const { getters } = madeStore;

        const isFrontLoaded =
          !getters["artwork_front/artworkCamelCase"]?.isSimulated ||
          getters["artwork_front/uploadArtwork"];
        const isBackLoaded =
          !getters["artwork_back/artworkCamelCase"]?.isSimulated ||
          getters["artwork_back/uploadArtwork"];

        this.#artworkExists = isFrontLoaded || isBackLoaded;

        // Recheck visibility after state update
        setTimeout(() => {
          this.checkInputVisibility();
          this.toggleButtonsVisibility();
        }, 0);
      });
    } else {
      madeStore.watch(
        state => {
          const isFrontLoaded = !!state.artwork_front.artwork || state.artwork_front.uploadArtwork;
          const isBackLoaded = !!state.artwork_back.artwork || state.artwork_back.uploadArtwork;
          return isFrontLoaded || isBackLoaded;
        },
        artworkExists => {
          this.#artworkExists = artworkExists;
          // Recheck visibility after state update
          setTimeout(() => {
            this.checkInputVisibility();
            this.toggleButtonsVisibility();
          }, 0);
        },
        { immediate: true }
      );
    }
  }
}

export default () =>
  new ProductDetailsUploadButton({
    eventSelector: ".js-product-details-upload-button"
  });
